import { connect } from 'react-redux';
import ManageCashJournal from '../../../../views/Finance/Bookkeeping/CashJournal/ManageCashJournal.finance.view';
import {
  manageCashJournal, getCashJournalById, getTaxRecipientParam, calculateTax, getTaxPtkpParam,
  getAvailableFundRequests, deleteJournalItem} from '../../../../states/thunks/finance.thunk';
import { getJournalCoaOptions, getCoaOptions, getPlafondOptions, getUnitOptions, getPerwakilanOptions } from '../../../../states/thunks/options.thunk';

function mapStateToProps(state) {
  return {
    coa: state.options.coa,
    plafond: state.options.plafond,
    user: state.user || {},
    unit: state.options.unit,
    perwakilan: state.options.perwakilan,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleDeleteJournalDetail: payload => dispatch(deleteJournalItem(payload)),
    handleGetTaxPtkpParam: payload => dispatch(getTaxPtkpParam(payload)),
    handleGetAvailableFundRequests: payload => dispatch(getAvailableFundRequests(payload)),
    handleGetTaxRecipientParam: payload => dispatch(getTaxRecipientParam(payload)),
    handleCalculateTax: payload => dispatch(calculateTax(payload)),
    handleGetCoaOptions: payload => dispatch(getCoaOptions(payload)),
    handleGetJournalCoaOptions: payload => dispatch(getJournalCoaOptions(payload)),
    handleGetCoa: payload => dispatch(getCoaOptions(payload)),
    handleGetCashJournal: payload => dispatch(getCashJournalById(payload)),
    handleGetPlafondOptions: payload => dispatch(getPlafondOptions(payload)),
    handleManageCashJournal: (payload, goBack) => dispatch(manageCashJournal(payload, goBack)),
    handleGetUnitOptions: payload => dispatch(getUnitOptions({ payload })),
    handleGetPerwakilanOptions: payload => dispatch(getPerwakilanOptions({payload })),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageCashJournal);
